import { Grid, Box, Switch, Stack, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { FormProvider, useForm, Controller } from 'react-hook-form';
import {
  InvoiceTermCondition,
  saveTermCondition,
  getAllTermCondition,
  updatePaymentVisibilityStatusTerms,
  InvoiceTermConditionDefault,
} from 'wisestep-api';
import { WsTypography, WsTypoVariants, Label, WsButton, ControlledTextInput } from 'wisestep-base';

import { SettingsPageLayout } from '../../../components/SettingsPageLayout';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { success, warning, failed } from '../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../utils/NotificationStore';
import { invoiceSettingsIndexOptions } from '../../invoicing/helper/InvocieSettingsHelper';

const updateStatusQuery: InvoiceTermConditionDefault = {
  isDefault: false,
};

const TermsAndConditions = () => {
  const methods = useForm();
  const {
    handleSubmit,
    setValue,
    formState: { isSubmitSuccessful },
  } = methods;

  useEffect(() => {
    setValue('description', '');
  }, [isSubmitSuccessful, setValue]);

  const setNotification = useNotificationStore((state) => state.setNotification);
  const [getInvoiceTermData, setInvoiceTermData] = useState<InvoiceTermCondition>();
  const [isTermData, setIsTermData] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [termID, sertTermID] = useState<string>();
  const [flag, setFlag] = useState<boolean>(false);

  useEffect(() => {
    (async function () {
      try {
        const getAllTermConditionReq = await getAllTermCondition();
        if (getAllTermConditionReq.data.length > 0) {
          setIsTermData(false);
          setInvoiceTermData(getAllTermConditionReq.data[0]);
          sertTermID(getAllTermConditionReq.data[0].id);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [flag]);

  const onSubmit = async (data) => {
    try {
      if (isEditing) {
        const exitTermCondition = {
          descriptionData: { des: data.description },
          id: termID,
          isDefault: getInvoiceTermData?.isDefault,
        };
        await saveTermCondition(exitTermCondition);
        setNotification(success('Term condition edited successfully.'));
        setIsEditing(false);
        setIsTermData(false);
        setFlag(!flag);
      } else {
        const newTermCondition = {
          descriptionData: { des: data.description },
          isDefault: true,
        };

        await saveTermCondition(newTermCondition);
        setNotification(success('Term condition added successfully.'));
        setIsTermData(false);
        setFlag(!flag);
      }
      showData();
    } catch (error) {
      setNotification(warning('Something Went Wrong, Please try again'));
    }
  };

  const editTest = () => {
    setIsEditing(true);
    setIsTermData(true);
    if (getInvoiceTermData) {
      setValue('description', getInvoiceTermData.descriptionData?.des);
    }
  };

  const showData = () => {
    setIsEditing(false);
    setIsTermData(false);
  };

  const onUpdateDefault = async (data) => {
    try {
      updateStatusQuery.isDefault = data;
      await updatePaymentVisibilityStatusTerms(termID as string, updateStatusQuery);
      setNotification(success('Visibility status has been updated successfully !!'));
      setFlag(!flag);
    } catch {
      setNotification(failed('Something went wrong , Please try again !!'));
    }
  };

  return (
    <SettingsPageLayout
      title="Terms and Conditions"
      indexOptions={invoiceSettingsIndexOptions}
      breadCrumnbsList={getSettingBreadCrumbList(
        ISettingBreadCrumbTypes.INVOICE,
        Pages['TERMS_AND_CONDITIONS']
      )}
    >
      <Box component="form" px={8} pt={2}>
        <Grid container direction="column" rowSpacing={2} xs={8} mb={2}>
          <Grid item display="flex" justifyContent="space-between" sx={{ alignItems: 'center' }}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE}>
              Customize Your Terms and Conditions Content
            </WsTypography>
          </Grid>
        </Grid>
        <Grid container rowSpacing={2} xs={12} mb={0}>
          {!isTermData && getInvoiceTermData && (
            <>
              <Grid item xs={9} mt={2} borderRadius={1.5}>
                <FormProvider {...methods}>
                  <ControlledTextInput
                    name="Description"
                    labelText="Description"
                    type="text"
                    fullWidth
                    id="des"
                    value={getInvoiceTermData.descriptionData?.des}
                    variant="outlined"
                    multiline
                  />
                  <Stack mt={2} spacing={2} direction="row">
                    <Controller
                      name="enabled"
                      render={() => (
                        <Grid container direction="column">
                          <Label>Is Default</Label>
                          <Switch
                            defaultChecked={getInvoiceTermData.isDefault}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                              onUpdateDefault(event.target.checked);
                            }}
                          />
                        </Grid>
                      )}
                    />
                    <WsButton onClick={() => editTest()} variant="outlined">
                      Edit
                    </WsButton>
                  </Stack>
                </FormProvider>
              </Grid>
            </>
          )}
          {isTermData && (
            <>
              <Grid item xs={10}>
                <FormProvider {...methods}>
                  <ControlledTextInput
                    name="description"
                    label={
                      isEditing ? 'Edit Terms and conditions ' : 'Add new Terms and Conditions'
                    }
                    sx={{ mb: '1vw' }}
                    size="small"
                    fullWidth
                    multiline
                  />
                  <Stack mt={4} direction="row" justifyContent="flex-end" spacing={2}>
                    <WsButton size="small" type="submit" onClick={handleSubmit(onSubmit)}>
                      {isEditing ? 'Save' : 'Add'}
                    </WsButton>
                    {isEditing && (
                      <>
                        <Button size="small" onClick={() => showData()}>
                          {'Cancel'}
                        </Button>
                      </>
                    )}
                  </Stack>
                </FormProvider>
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    </SettingsPageLayout>
  );
};

export default TermsAndConditions;
